import { forwardRef } from "react";

import { ColorPickerInput } from "@shared/components/DataEntry";

import { FormField } from "../FormField";
import { FormColorPickerInputProps } from "../../types";

export const FormColorPickerInput = forwardRef<HTMLInputElement, FormColorPickerInputProps>(
  ({ name, ...props }, ref) => (
    <FormField name={name}>
      <ColorPickerInput ref={ref} name={name} {...props} />
    </FormField>
  )
);

FormColorPickerInput.displayName = "Form.ColorPickerInput";
